import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {history, Switch, stores} from 'mutants-microfx';
import {Redirect} from 'react-router';
import Portal from '../portal/page';
import {platform_browser} from '../../utils';
import {CacheSwitch} from 'react-router-cache-route';


@observer
export default class Main extends Component {

  state = {};

  static childContextTypes = {
  };

  getChildContext() {
    return {
    };
  }


  render() {
    const {match: {isExact} = {}, routes} = this.props;
    const pathname = history.location.pathname;
    if (!stores.user.isLogin && !~pathname.indexOf('login')) {
      //临时使用友空间在线模式调试
      return <Redirect to={'/login'}/>;
      // if (platform_browser) {
      //   return <Redirect to={'/login'}/>
      // } else {
      //   destroyApp(); //工作圈关闭app
      // }
    }
    return (
        <div className='app-main-container'>
          {isExact ? <Portal /> : <CacheSwitch>{routes}</CacheSwitch>}
        </div>
    );
  }

  
}
